import PropTypes from 'prop-types';
import React from 'react';

/* eslint-disable react/jsx-no-useless-fragment */
var propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};
var defaultProps = {
  value: null,
  placeholder: null
};
var Text = function Text(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder;
  return /*#__PURE__*/React.createElement(React.Fragment, null, value || placeholder);
};
Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export { Text as default };
